import cn from 'classnames';
import React from 'react';

function HoverBounce(props) {
  return <div className={cn('bounceElement flex')}>{props.children}</div>;
}

export default HoverBounce;
